export default __webpack_public_path__ + "static/automotive2-d54ca1aefa41cfbf258e304d0bc71eaa.jpeg";